import { mapTourActiveElementStyles } from 'pages/Map/components/MapTour/MapTour.styled';
import { Position } from 'pages/Map/types';
import styled from 'styled-components';

export const Container = styled.div`
    overflow: hidden;
    display: flex;
    width: 100%;
    height: 100%;
`;

export const MapContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`;

export const MapLayout = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    position: relative;
    overflow: hidden;

    .react-transform-wrapper {
        height: 100%;
        flex: 1 0;
    }
`;

export const Map = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    min-height: 100vh;
`;

export const StationsWrapper = styled.div`
    position: relative;
`;

export const PathDescriptions = styled.div`
    position: relative;
`;

export const TourActiveDrawerAndStationElement = styled.div<{ position: Position; withTimeline: boolean }>`
    width: ${({ withTimeline }) => (withTimeline ? '45rem' : '35rem')};
    height: 10rem;
    position: absolute;
    z-index: -2;
    left: ${({ position, withTimeline }) => (withTimeline ? `${position.x - 100}px` : `${position.x - 30}px`)};
    top: ${({ position }) => `${position.y - 30}px`};
    ${mapTourActiveElementStyles}
`;
